import { Injectable } from '@angular/core';

/**
 * Browser PUT to a presigned S3 URL. Uses `fetch` so the EVready API auth
 * interceptor is not involved and no bearer token is sent to S3.
 */
@Injectable({
  providedIn: 'root'
})
export class StorageUploadService {
  putFile(url: string, body: Blob, headers: Record<string, string>): Promise<Response> {
    // Presigned PUT + Content-Type are signed; method must stay PUT. Following a 301/302
    // with fetch can retry as GET and yields SignatureDoesNotMatch from S3.
    return fetch(url, { method: 'PUT', headers, body, redirect: 'error' });
  }
}
